import { isBoolean } from 'lodash';
import React from 'react';
import { imageUrl } from '../helper';

export function Signature(props) {
  const { CustomAddEditAccess, placeholder, rowIndex, colIndex, digitalSignPath, fontFamily, handleUpdateSignature, fromProduct, isProductArchived } = props;
  let logo = null;
  if (digitalSignPath?.includes('base64')) {
    logo = digitalSignPath;
  } else {
    logo = `${imageUrl}/${digitalSignPath}`;
  }

  return (
    <div className="position-relative d-flex align-items-center">
      {fromProduct && (
        <button
          type="submit"
          disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
          onClick={() => handleUpdateSignature(rowIndex, colIndex)}
          className="btn p-0 px-1"
        >
          <span className="sr-only">Edit</span>
          <i className="icon-edit" />
        </button>
      )}
      <div className="text-center flex-fill">
        {digitalSignPath && digitalSignPath !== '' ? (
          <img src={logo} className="signature-image-table" alt="" />
        ) : (
          <p className="f-20 mb-0" style={{ fontFamily }}>
            {placeholder}
          </p>
        )}
      </div>
    </div>
  );
}
export default Signature;
